import "../styles/components/Message.scss";

function Message({ message }) {
  return <h1 className="Message">{message}</h1>;
}

export default Message;
